import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";

export const ReCaptcha = () => {
  const domain = window.location.hostname; // 💡 Not in `location`
  if (domain === "app.rankspro.io") {
    return (
      <GoogleReCaptchaProvider reCaptchaKey="6LdlFXkpAAAAAOxfzJ7-v8LvgUi-i1dQqaqvz81f" />
    );
  } else {
    return null;
  }
};
